export const SITE_ORIGIN = 'https://www.centumth.com';

export type PageMeta = {
  title: string;
  description: string;
  path: string;
};

export const PAGE_META = {
  home: {
    title: 'Centumth — Daily Top 100 Guessing Game',
    description:
      'Centumth is a daily guessing game. One topic, a hidden Top 100, five guesses. Aim for the answers closest to #100.',
    path: '/',
  },
  play: {
    title: 'Play Today — Centumth',
    description:
      'Play today’s Centumth. Guess the hidden gems on a hand-ranked Top 100 and score the ranks closest to #100.',
    path: '/play',
  },
  archive: {
    title: 'Archive — Centumth',
    description:
      'Replay every past Centumth topic. Same rules: five guesses, chase the answers closest to #100.',
    path: '/archive',
  },
  news: {
    title: 'News — Centumth',
    description:
      'What’s new in Centumth — features, list-quality updates, and the changes that shape the daily game.',
    path: '/news',
  },
  about: {
    title: 'About us — Centumth',
    description:
      'The story behind Centumth, how the daily Top 100 lists are made, and how to reach founder Eliass Lalaoui.',
    path: '/about',
  },
  privacy: {
    title: 'Privacy Policy — Centumth',
    description:
      'How Centumth collects and uses play data, local storage, analytics, and advertising information.',
    path: '/privacy-policy',
  },
  howToPlay: {
    title: 'How to Play — Centumth',
    description:
      'How Centumth works: one topic, a hidden Top 100, five guesses. Obvious answers score low. Hidden gems near #100 score big.',
    path: '/how-to-play',
  },
  you: {
    title: 'You — Centumth',
    description: 'Your Centumth stats, medals, streaks, and achievements.',
    path: '/you',
  },
  notFound: {
    title: 'Page not found — Centumth',
    description: 'This page does not exist. Head back to Centumth to play today’s Top 100.',
    path: '/404',
  },
} as const satisfies Record<string, PageMeta>;
